var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpiredproposal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52.6 56.6",
    style: {
      enableBackground: "new 0 0 52.6 56.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#425EAB;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#425EAB;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#DE2F27;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,30.9V11.8c0-0.4-0.2-0.8-0.5-1.1l-8.3-8.3c-0.3-0.3-0.7-0.5-1.1-0.5H4.4c-0.9,0-1.6,0.7-1.6,1.6l0,0v49.5 c0,0.9,0.7,1.6,1.6,1.6h24.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.4,1.9v9c0,0.9,0.7,1.6,1.6,1.6h9"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 33.7,
    cy: 33,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 33.7,
    cy: 33,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.1,27.2h1.3V33h-1.3V27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.5,35.6l-1.1,1.1l-3.2-3.2l1.1-1.1L37.5,35.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 33.7,
    cy: 33,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 33.7,
    cy: 33,
    r: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.3,49.9L40,33.6c0.4-0.6,1.2-0.8,1.8-0.5c0.2,0.1,0.4,0.3,0.5,0.5L52,49.9c0.4,0.7,0.1,1.5-0.5,1.9 c-0.2,0.1-0.4,0.2-0.7,0.2H31.4c-0.7,0-1.3-0.6-1.3-1.4C30.1,50.3,30.2,50.1,30.3,49.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.1,48.4c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3s0.2-0.1,0.3-0.2c0.1-0.1,0.3-0.1,0.4-0.1 c0.2,0,0.3,0,0.5,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.1,0.3,0.1,0.4c0,0.1,0,0.3-0.1,0.4 C42,49,42,49,41.9,49.2s-0.2,0.1-0.3,0.2c-0.1,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.3-0.2 c-0.1-0.1-0.1-0.2-0.2-0.3C40.1,48.7,40.1,48.6,40.1,48.4 M42,46.3h-1.6l-0.3-6.6h2L42,46.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredproposal);
export default __webpack_public_path__ + "static/media/Expired proposal.925fbf8b0c04e09329eba39f3ac1ec5f.svg";
export { ForwardRef as ReactComponent };